import { apiClient } from "@/modules/shared/utils/apiClient";

export type GetCancelPreviewResponse = {
  session: {
    id: number;
    start: string;
    end: string;
    coachName: string;
    coachId: number;
    customerId: number;
  };
  canCancel: boolean;
  isLateCancel: boolean;
};

export const getCancelPreview = (sessionCode: string) => {
  const params = new URLSearchParams({ sessionCode }).toString();

  return apiClient.get<GetCancelPreviewResponse>(
    `/coaching-session/cancel/preview?${params}`,
  );
};
